import React from 'react';
import { CircularProgress } from '@mui/material';
import { GREEN_LOGO, GREEN_MAIN } from '../../theme/colors';

interface WaiterProps{
  width:number,
  size:number
}

const CustomWaiter:React.FC<WaiterProps> = ({width, size}) => {
  return (
    <div style={{ width: width+'px', height: width+'px' }}>
      <CircularProgress style={{ color:GREEN_LOGO }} size={size} thickness={5} />
    </div>
  );
};

export default CustomWaiter;